import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
var useStyles = makeStyles(function (theme) { return ({
    companyName: function (props) { return ({
        padding: theme.spacing(1),
        color: props.couponIssuerTextColor,
        backgroundColor: props.couponIssuerBandColor,
        textAlign: 'center',
    }); },
}); });
/**
 * 発行者組織名。必ず入っている。
 */
export var CompanyName = function (props) {
    var classes = useStyles(props);
    return (React.createElement(Box, { className: classes.companyName },
        React.createElement(Typography, { variant: 'h6' }, props.companyName)));
};
//# sourceMappingURL=CompanyName.js.map